import { render, staticRenderFns } from "./ProductFormPage.vue?vue&type=template&id=81d2a9da"
import script from "./ProductFormPage.vue?vue&type=script&lang=js"
export * from "./ProductFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports